export const FETCH_USER_REQUESTED = 'FETCH_USER_REQUESTED'
export const PUT_USER_PASSWORD_REQUESTED = 'PUT_USER_PASSWORD_REQUESTED'
export const FETCH_USER_SUCCEEDED = 'FETCH_USER_SUCCEEDED'
export const FETCH_USER_FAILED = 'FETCH_USER_FAILED'
export const PUT_USER_PASSWORD_SUCCEEDED = 'PUT_USER_PASSWORD_SUCCEEDED'
export const PUT_USER_PASSWORD_FAILED = 'PUT_USER_PASSWORD_FAILED'
export const LOGOUT_SUCCEEDED = 'LOGOUT_SUCCEEDED'
export const FETCH_USER_FOR_COMMS_REQUESTED = 'FETCH_USER_FOR_COMMS_REQUESTED'
export const SELECT_ACCOUNT = 'SELECT_ACCOUNT'
export const SET_SHOW_ACCOUNT_TOOLTIP = 'SET_SHOW_ACCOUNT_TOOLTIP'
export const SET_SHOW_CLIENTS_TOOLTIP = 'SET_SHOW_CLIENTS_TOOLTIP'
export const SELECT_CLIENT = 'SELECT_CLIENT'
export const UPDATE_USER_TIMEZONE_REQUESTED = 'UPDATE_USER_TIMEZONE_REQUESTED'
export const UPDATE_USER_TIMEZONE_SUCCEEDED = 'UPDATE_USER_TIMEZONE_SUCCEEDED'
export const UPDATE_USER_TIMEZONE_FAILED = 'UPDATE_USER_TIMEZONE_FAILED'
export const FETCH_BUFFER_SUCCEEDED = 'FETCH_BUFFER_SUCCEEDED'
export const PUT_PASSWORD_MATCHES_REQUESTED = 'PUT_PASSWORD_MATCHES_REQUESTED'
export const PUT_PASSWORD_MATCHES_SUCCEEDED= 'PUT_PASSWORD_MATCHES_SUCCEEDED'
export const PUT_PASSWORD_MATCHES_FAILED = 'PUT_PASSWORD_MATCHES_FAILED'
export const FETCH_ALL_USERS_DETAILS_REQUESTED = 'FETCH_ALL_USERS_DETAILS_REQUESTED'
export const FETCH_ALL_USERS_DETAILS_SUCCEEDED = 'FETCH_ALL_USERS_DETAILS_SUCCEEDED'
export const FETCH_ALL_USERS_DETAILS_FAILED = 'FETCH_ALL_USERS_DETAILS_FAILED'
export const UPDATE_ALLOW_CONTACT_BY_EMAIL_REQUESTED = 'UPDATE_ALLOW_CONTACT_BY_EMAIL_REQUESTED'
export const UPDATE_ALLOW_CONTACT_BY_EMAIL_SUCCEEDED = 'UPDATE_ALLOW_CONTACT_BY_EMAIL_SUCCEEDED'
export const UPDATE_ALLOW_CONTACT_BY_EMAIL_FAILED = 'UPDATE_ALLOW_CONTACT_BY_EMAIL_FAILED'
